import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Moment from 'moment';
import {
  getSalesPerformancePerSales,
  getTracker
} from 'src/services/SalesPerformance/SalesPerformance';
import {
  CButton,
  CCard,
  CCol,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow
} from '@coreui/react';
import { DateRangePicker } from 'react-date-range';
import SummaryDownload from '../summary/Download/Summary';
import { CChartBar, CChartLine } from '@coreui/react-chartjs';
import { getStyle, hexToRgba } from '@coreui/utils';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import ls from 'local-storage';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.js';
import { getTrackerAddress } from 'src/services/SalesPerformance/Leaflet';

const iconLocation = new L.Icon({
  iconUrl: require('./img/pin-location2.png'),
  iconSize: [70, 75]
});

const Container = (props) => {
  return (
    <MapContainer
      center={[-6.921418065585008, 107.61101770471431]}
      zoom={15}
      style={{ width: '100%', height: '100vh' }}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {props.data.length > 0 &&
        props.data
          .filter((item, i) => {
            return !isNaN(item.lat) || !isNaN(item.lng);
          })
          .map((item, i) => {
            return (
              <Marker icon={iconLocation} position={[item.lat, item.lng]}>
                <Popup>
                  <div>{item.name}</div>
                  <div>{item.address}</div>
                </Popup>
              </Marker>
            );
          })}
    </MapContainer>
  );
};

const Tracker = (props) => {
  const [placeName, setPlaceName] = useState('');

  async function fetchName(lat, lng) {
    const response = await getTrackerAddress(lat, lng);

    setPlaceName(response.data.display_name);
  }

  function clickMarker(lat, lng, e) {
    fetchName(lat, lng);
  }

  return (
    <MapContainer
      center={[-6.921418065585008, 107.61101770471431]}
      zoom={13}
      style={{ width: '100%', height: '100vh' }}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {props.data.length > 0 &&
        props.data
          .filter((item, i) => {
            return !isNaN(item.lat) || !isNaN(item.lng);
          })
          .map((item, i) => {
            return (
              <Marker
                icon={iconLocation}
                position={[item.lat, item.lng]}
                eventHandlers={{
                  click: (e) => {
                    setPlaceName('');
                    clickMarker(item.lat, item.lng, e);
                  }
                }}
              >
                <Popup>
                  <p>{`${placeName}`}</p>
                  <p>{`${item.time}`}</p>
                </Popup>
              </Marker>
            );
          })}
    </MapContainer>
  );
};

function SalesPerformanceDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const salesID = location.state.salesID;

  const [chartLineLabel, setChartLineLabel] = useState([]);
  const [chartLineData, setChartLineData] = useState([]);

  const [summaryData, setSummaryData] = useState([]);

  const [byDeals, setByDeals] = useState([]);
  const [byPackage, setByPackage] = useState([]);
  const [byPos, setByPos] = useState([]);
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [mapsMarker, setMapsMarker] = useState([]);
  const [tracker, setTracker] = useState({});

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);

  const [dateRange, setDateRange] = useState([
    {
      // startDate: ls.get("dateRange") ? new Date(ls.get("dateRange").startDate) : new Date(`${Moment(new Date()).startOf('month').format("MMM dd YYYY")}`),
      startDate: new Date(
        `${Moment(new Date()).startOf('month').format('MMM dd YYYY')}`
      ),
      endDate: new Date()
    }
  ]);
  // endDate: ls.get("dateRange") ? new Date(ls.get("dateRange").endDate) : new Date()}])

  async function fetchTracker(from, to, id) {
    const response = await getTracker(from, to, id);

    if (
      response['data'] !== undefined &&
      response['data'] !== null &&
      response['data'].length > 0
    ) {
      const data = response['data'].map((item) => {
        return {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
          time: item.created_at
        };
      });
      setTracker(data);
    } else {
      setTracker([]);
    }
  }

  async function fetchSummary(from, to, id) {
    const response = await getSalesPerformancePerSales(from, to, id);

    if (
      response['visits'] !== undefined &&
      response['visits'] !== null &&
      response['visits'].length > 0
    ) {
      const data = response['visits'].map((item) => {
        return {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
          name: item.merchant_name,
          address: item.address
        };
      });

      setMapsMarker(data);
    } else {
      setMapsMarker([]);
    }

    if (response['package'].length > 0 && response['package'] !== undefined) {
      const data = response['package'].map((item) => {
        if (item.package_type === '0') {
          return { count: item.count, package_type: 'Tidak Tertarik' };
        } else if (item.package_type === '1') {
          return { count: item.count, package_type: 'Trial' };
        } else if (item.package_type === '2') {
          return { count: item.count, package_type: 'Free' };
        } else if (item.package_type === '3') {
          return { count: item.count, package_type: 'Lite' };
        } else if (item.package_type === '4') {
          return { count: item.count, package_type: 'Business' };
        } else if (item.package_type === '5') {
          return { count: item.count, package_type: 'Professional' };
        } else {
          return { count: item.count, package_type: 'Lainnya' };
        }
      });
      setByPackage(data);
    } else {
      setByPackage([]);
    }

    if (response['pos'].length > 0 && response['pos'] !== undefined) {
      const data = response['pos'].map((item) => {
        let returnedItem = item;
        if (item.current_pos === '0') {
          returnedItem.current_pos = 'Belum Pakai POS';
        } else if (item.current_pos === '1') {
          returnedItem.current_pos = 'Moka';
        } else if (item.current_pos === '2') {
          returnedItem.current_pos = 'Majoo';
        } else if (item.current_pos === '3') {
          returnedItem.current_pos = 'Olsera';
        } else if (item.current_pos === '4') {
          returnedItem.current_pos = 'iSeller';
        } else if (item.current_pos === '5') {
          returnedItem.current_pos = 'Pawoon';
        } else if (item.current_pos === '6') {
          returnedItem.current_pos = 'FolioPOS';
        } else if (item.current_pos === '7') {
          returnedItem.current_pos = 'Youtap';
        } else if (item.current_pos === '1000') {
          returnedItem.current_pos = 'Spots';
        } else if (item.current_pos === '1001') {
          returnedItem.current_pos = 'Loyverse';
        } else if (item.current_pos === '1002') {
          returnedItem.current_pos = 'Quinos';
        } else if (item.current_pos === '1003') {
          returnedItem.current_pos = 'Qasir';
        } else if (item.current_pos === '1004') {
          returnedItem.current_pos = 'POST';
        } else if (item.current_pos === '1005') {
          returnedItem.current_pos = 'Mille';
        } else if (item.current_pos === '1006') {
          returnedItem.current_pos = 'Luna POS';
        } else if (item.current_pos === '1007') {
          returnedItem.current_pos = 'Cash Register';
        } else if (item.current_pos === '1008') {
          returnedItem.current_pos = 'Kasir Pintar';
        } else if (item.current_pos === '1009') {
          returnedItem.current_pos = 'Gobiz';
        } else if (item.current_pos === '1010') {
          returnedItem.current_pos = 'ESB';
        } else if (item.current_pos === '1011') {
          returnedItem.current_pos = 'DRetail';
        } else {
          returnedItem.current_pos = 'Lainnya';
        }
        return returnedItem;
      });
      setByPos(data);
    } else {
      setByPos([]);
    }

    if (response['visitByDate'] !== null) {
      const label = response['visitByDate'].map((item) => {
        return item.date.slice(5).replace('-', '/');
      });

      const data = response['visitByDate'].map((item) => {
        return item.counter;
      });

      setChartLineLabel(label);
      setChartLineData(data);
    } else {
      setChartLineData([]);
      setChartLineLabel([]);
    }

    setSummaryData(response);

    setByDeals(response['deals']);
  }

  function toSQLDateFormat(date) {
    return Moment(new Date(date)).format('YYYY-MM-DD');
  }

  useEffect(() => {
    if (!salesID) {
      navigate(-1);
    } else {
      const newStartDay = toSQLDateFormat(dateRange[0].startDate);
      const newEndDay = toSQLDateFormat(dateRange[0].endDate);

      fetchSummary(newStartDay, newEndDay, salesID);
      fetchTracker(newStartDay, newEndDay, salesID);
    }
  }, [refetch, dateRange]);

  return (
    <>
      <CModal
        visible={drModal}
        style={{
          width: 'fit-content'
        }}
        onClose={() => {
          setDrModal(false);
        }}
      >
        <CModalHeader>
          <CModalTitle>Modal title</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
            />
          </CCol>
        </CModalBody>
        <CModalFooter>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => setDrModal(!drModal)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      <CCol xs="12 bg-light">
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>

        <CCard style={{ padding: '2vh 2vw' }}>
          <CRow>
            <CCol xs={6}>
              <p className="fs-3 fw-bold"> SALES PERFORMANCE </p>
            </CCol>
            {/* 
                        <CCol xs={6} style={{textAlign: "right"}}>
                            <SummaryDownload 
                                dateFrom={toSQLDateFormat(dateRange[0].startDate)}
                                dateUntil={toSQLDateFormat(dateRange[0].endDate)}
                                byPos={byPos}
                                byPackage={byPackage}
                                byDeals={byDeals}
                                total={summaryData.total}
                                totalDeals={summaryData.totalDeal}
                                totalPOS={summaryData.totalPOS}
                                totalPackage={summaryData.totalPackage}
                            />
                        </CCol> */}
          </CRow>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>{location.state.salesName}</span>
            </CRow>
            <CRow className="fs-6">
              <span>{location.state.salesEmail}</span>
            </CRow>
            <CRow className="fs-6">
              <span>{location.state.salesPhone}</span>
            </CRow>
          </div>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>Berdasarkan Rencana Kerja</span>
            </CRow>
            <CRow className="text-uppercase fs-6">
              <CCol xs="9" className="text-start">
                <span>Target</span>
              </CCol>
              <CCol xs="3" className="text-end">
                <span>{summaryData.totalWPTarget}</span>
              </CCol>
            </CRow>
            <CRow className="text-uppercase fs-6">
              <CCol xs="9" className="text-start">
                <span>Pencapaian</span>
              </CCol>
              <CCol xs="3" className="text-end">
                <span>{summaryData.totalWPCount}</span>
              </CCol>
            </CRow>
          </div>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>Berdasarkan Paket yang Diambil</span>
            </CRow>
            {byPackage.length > 0 ? (
              byPackage.map((item, index) => {
                return (
                  <CRow key={index}>
                    <CCol xs="9" className="text-start">
                      <span>{item.package_type}</span>
                    </CCol>
                    <CCol xs="3" className="text-end">
                      <span>{item.count}</span>
                    </CCol>
                  </CRow>
                );
              })
            ) : (
              <CHeader style={{ color: 'silver', marginBottom: '2vh' }}>
                <p style={{ padding: '0vh 0vw 0vh 2vw' }}>
                  Data Tidak Ditemukan
                </p>
              </CHeader>
            )}
            {byPackage.length > 0 ? (
              <CRow className="text-uppercase fs-6 fw-bolder">
                <CCol xs="9" className="text-start">
                  <span>Total</span>
                </CCol>
                <CCol xs="3" className="text-end">
                  <span>{summaryData.totalPackage}</span>
                </CCol>
              </CRow>
            ) : (
              <div></div>
            )}
          </div>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>Berdasarkan POS yang Digunakan</span>
            </CRow>
            {byPos.length > 0 ? (
              byPos.map((item, index) => {
                return (
                  <CRow key={index}>
                    <CCol xs="9" className="text-start">
                      <span>{item.current_pos}</span>
                    </CCol>
                    <CCol xs="3" className="text-end">
                      <span>{item.count}</span>
                    </CCol>
                  </CRow>
                );
              })
            ) : (
              <CHeader style={{ color: 'silver', marginBottom: '2vh' }}>
                <p style={{ padding: '0vh 0vw 0vh 2vw' }}>
                  Data Tidak Ditemukan
                </p>
              </CHeader>
            )}
            {byPos.length > 0 ? (
              <CRow className="text-uppercase fs-6 fw-bolder">
                <CCol xs="9" className="text-start">
                  <span>Total</span>
                </CCol>
                <CCol xs="3" className="text-end">
                  <span>{summaryData.totalPOS}</span>
                </CCol>
              </CRow>
            ) : (
              <div></div>
            )}
          </div>

          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>Berdasarkan Merchant</span>
            </CRow>
          </div>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <CCol xs="9" className="text-start">
                <span>Total</span>
              </CCol>
              <CCol xs="3" className="text-end">
                <span>{summaryData.totalMerchant}</span>
              </CCol>
            </CRow>
          </div>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>Kunjungan Per Hari</span>
            </CRow>
          </div>
          {chartLineData.length > 1 ? (
            <div className="mt-3 mb-3">
              <CChartLine
                style={{ height: '300px', marginTop: '40px' }}
                data={{
                  labels: chartLineLabel,
                  datasets: [
                    {
                      label: 'Data Kunjungan',
                      backgroundColor: hexToRgba(getStyle('--cui-info'), 10),
                      borderColor: getStyle('--cui-info'),
                      pointHoverBackgroundColor: getStyle('--cui-info'),
                      borderWidth: 2,
                      data: chartLineData,
                      fill: true
                    }
                  ]
                }}
                options={{
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      display: false
                    }
                  },
                  scales: {
                    x: {
                      grid: {
                        drawOnChartArea: false
                      }
                    },
                    y: {
                      ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 5,
                        stepSize: Math.ceil(250 / 5),
                        max: 250
                      }
                    }
                  },
                  elements: {
                    line: {
                      tension: 0.4
                    },
                    point: {
                      radius: 0,
                      hitRadius: 10,
                      hoverRadius: 4,
                      hoverBorderWidth: 3
                    }
                  }
                }}
              />
            </div>
          ) : chartLineData.length === 1 ? (
            <div className="mt-3 mb-3">
              <CChartBar
                height="80"
                data={{
                  labels: ['Visit By Date'],
                  datasets: [
                    {
                      label: chartLineLabel[0],
                      backgroundColor: '#4E5B97',
                      data: [chartLineData[0]],
                      maxBarThickness: 50
                    }
                  ]
                }}
                labels="Date"
              />
            </div>
          ) : (
            <CCard
              style={{
                height: '30vh',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'silver'
              }}
            >
              <p>Data Tidak Ditemukan</p>
            </CCard>
          )}
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder mb-3">
              <span>Sebaran Kunjungan</span>
            </CRow>
            <Container data={mapsMarker} />
          </div>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder mb-3">
              <span>Tracker</span>
            </CRow>
            <Tracker data={tracker} />
          </div>
        </CCard>
      </CCol>
    </>
  );
}

export default SalesPerformanceDetails;
